import React from 'react';
import {Box} from '@mui/material';
import {normalizeEeiPriority} from '../../../firebase/firestore/eei';

export function icrPriorityTextColor(priority) {
    const normalized = normalizeEeiPriority(priority);
    if (normalized === 'High') return 'error.main';
    if (normalized === 'Medium') return 'warning.dark';
    return 'success.main';
}

/**
 * ICR header priority pill: light gray background, colored "High Priority" text.
 * Shorter than Edit/Delete buttons.
 */
export default function IcrPriorityLabel({priority}) {
    const normalized = normalizeEeiPriority(priority);

    return (
        <Box
            component="span"
            aria-label={`${normalized} Priority`}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                px: 1.25,
                py: 0.125,
                minHeight: 24,
                borderRadius: 1.5,
                bgcolor: '#EBEDF0',
                fontSize: '0.8125rem',
                fontWeight: 700,
                lineHeight: 1.35,
                color: icrPriorityTextColor(normalized),
                userSelect: 'none',
            }}
        >
            {`${normalized} Priority`}
        </Box>
    );
}
